import BaseFactory from 'services/sports/default/base-factory';
import Const from 'constants';
import PlayerClassic from 'services/sports/tennis/player/classic';

const classesMap = {
    [Const.GAME_TYPE_CLASSIC]: PlayerClassic,
};

class Factory extends BaseFactory {
    createObj(objectName, params) {
        const {sportConfig} = params;
        const gameType = sportConfig.getGameType();

        if (gameType in classesMap) {
            return new classesMap[gameType](params);
        }

        throw new Error(`Unknown gameType "${gameType}".`);
    }
}

export {Factory};
